// extracted by mini-css-extract-plugin
export default {"divInOptions":"reactSelectCustomStyles_divInOptions__Fxv8L","buttonInOptions":"reactSelectCustomStyles_buttonInOptions__N+fIs"};